import { render, staticRenderFns } from "./group-edit.vue?vue&type=template&id=2481fb0c&"
import script from "./group-edit.vue?vue&type=script&lang=ts&"
export * from "./group-edit.vue?vue&type=script&lang=ts&"
import style0 from "./group-edit.vue?vue&type=style&index=0&id=2481fb0c&prod&lang=scss&"
import style1 from "./group-edit.vue?vue&type=style&index=1&id=2481fb0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports